import { PageRouteBuilder } from "@common/route/page-route-builder";
import { OrganisationPageComponent } from "./organisation-page.component";

export const organisationPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-organisation-page", OrganisationPageComponent)
    .atUrl("/organisations/:organisationUrlIdentifier")
    .withTitle("Organisation Details")
    .reloadOnSearch(false)
    .build();
